import React, { useState } from "react";
import Button from "../buttons/Button";
import Text from "../typography/Text";
import defaultImage from "../../images/no-profile.png";
import ImageCrop from "./ImageCrop";

// https://gist.github.com/AshikNesin/e44b1950f6a24cfcd85330ffc1713513

// const getImageFile = dataUrl =>
//   new Promise(resolve => {
//     console.log({ dataUrl });
//     const reader = new FileReader();
//     reader.onload = e => resolve(e.target.result);
//     reader.readAsDataURL(dataUrl);
//   });

const ImageUpload = ({
  setFile,
  currentImage,
  label,
  notice,
  ...modifiers
}) => {
  const [showCropModal, setCropModal] = useState(false);
  const [imageSrc, setImageSrc] = useState();
  const [imageCropped, setImageCropped] = useState();

  const imageRef = React.useRef();
  const imgUrl =
    currentImage && currentImage.base_path
      ? currentImage.base_path + currentImage.breakpoints.lg["2x"]
      : currentImage;

  let className = "imageUpload";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );

  // When user uploads an image, ask him to crop it
  const onChange = event => {
    const image = event.target.files[0];
    const imageEl = imageRef.current;
    const reader = new FileReader();
    reader.onload = e => {
      imageEl.style.backgroundImage = `url(${e.target.result})`;
      setImageSrc(e.target.result);
      setCropModal(true);
    };
    reader.readAsDataURL(image);
  };

  // When uploaded image is cropped, close modal and set it as file
  const onCrop = async (croppedFile, croppedImageUrl) => {
    setImageCropped(croppedImageUrl);
    setCropModal(false);
    setFile(croppedFile);
  };

  return (
    <div className={className}>
      <div
        className="imageUpload_image"
        ref={imageRef}
        style={{
          backgroundImage: `url(${imageCropped || imgUrl || defaultImage})`
        }}
        onClick={() => !!imageSrc && setCropModal(true)}
      ></div>
      <div className="imageUpload_side">
        <div className="imageUpload_uploader">
          <Button icon="upload" outlined rounded>
            {label}
          </Button>
          <input
            type="file"
            className="imageUpload_input"
            accept="image/jpeg, image/png"
            onChange={onChange}
          />
        </div>
        <Text superSmall>{notice}</Text>
      </div>
      <ImageCrop
        show={showCropModal}
        setShow={setCropModal}
        src={imageSrc}
        onCrop={onCrop}
        ratio={1}
      />
    </div>
  );
};

export default ImageUpload;
